module.exports = __webpack_public_path__ + "static/media/diamond.da7d83c3.webp";